module.exports = __webpack_public_path__ + "static/gosite-promo-a6a9a877a0d35ae95bfb2955339659cb.mp4";